import * as React from 'react';
import Button from '@mui/material-next/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from "prop-types";
import { IconButton, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from "react-i18next";
import Stack from '@mui/material/Stack';
import * as Yup from "yup";
import { Formik, Form } from 'formik'
import BlurryDialog from '../../../widget/BlurryDialog';


const initComment = { comment: '' };

const KanbanCommentDialog = (props) => {
  const { t } = useTranslation();

  const descriptionElementRef = React.useRef(null);

  const KanbanCommentSchema = Yup.object().shape({
    comment: Yup.string()
      .required(t('validation.required'))
      .min(3, t('validation.minimumCharacters'))
  });

  React.useEffect(() => {
    if (props.open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [props.open]);

  return (
    <Formik
      enableReinitialize={true}
      initialValues={ props.cardCommentId != "" ? {comment: props.cardComment } : initComment}
      validationSchema={KanbanCommentSchema}
      onSubmit={(values, { resetForm }) => {
        props.handleSave(props.cardId, props.columnId, values.comment, props.cardCommentId, resetForm);
      }}
    >
      {({ handleSubmit, handleChange, values, setFieldValue, errors, isValid, dirty }) => (
        <Form>
          <BlurryDialog
            open={props.open}
            onClose={props.handleClose}
          >
            <DialogTitle
              id="scroll-dialog-title"
              className="color color-medium-purple">
              <b>
                {props.cardCommentId != "" ? t("kanban.comments.editComment") : t("kanban.comments.addComment")}
                
              </b>
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={props.handleClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
              }}
            >
              <CloseIcon />
            </IconButton>
            <DialogContent>
              <DialogContentText
                id="scroll-dialog-description"
                ref={descriptionElementRef}
                tabIndex={-1}
              >

                <Stack spacing={3}>
                  <TextField
                    id="dialog-kanban-comment"
                    name={'comment'}
                    multiline
                    rows={12}
                    value={values.comment}
                    error={errors.comment}
                    helperText={errors.comment}
                    onChange={handleChange}
                    label={t("kanban.comment")}
                    variant="outlined"
                    style={{ marginBottom: '15px' }}
                    size="small"
                    required
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "10px"
                      }
                    }}
                  />
                </Stack>

              </DialogContentText>
            </DialogContent>
            <DialogContent>
              <DialogActions>
                <Button
                  variant="filled"
                  disableElevation
                  disabled={!isValid || !dirty}
                  className="bg bg-medium-purple"
                  type="submit"
                  size="small"
                  style={{ borderRadius: '10px' }}
                  onClick={handleSubmit}
                >
                  {props.cardCommentId != "" ? t("save") : t("add")}
                </Button>
              </DialogActions>
            </DialogContent>
          </BlurryDialog>
        </Form>
      )}
    </Formik>
  );
}

KanbanCommentDialog.propTypes = {
  cardId: PropTypes.string,
  columnId: PropTypes.number,
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  handleSave: PropTypes.func,
  cardComment: PropTypes.string,
  cardCommentId: PropTypes.string
};

export default KanbanCommentDialog;